/************************************FILTER PROJECT***********************************/
class filterProjectServices extends HTMLElement {
    constructor(){
        super();

        this.btnFilter = this.querySelector('.btn');
        this.extraBtnFilter = document.querySelector('filter-industries .btn');
        this.itemsFilter = this.querySelectorAll('.item');
        this.active = this.parentNode;
        this.extraActive = document.querySelector('filter-industries').parentNode;

        this.menu = this.btnFilter.dataset.name;
        this.element = this.querySelector('#'+this.menu);
        this.extraElement = document.querySelector('#industries');
        this.height = this.element.scrollHeight;

        this.loadBtn = document.querySelector('load-moreprojects');

    }

    connectedCallback(){    
        this.btnFilter.addEventListener('click', this.onClickBtn.bind(this));
        this.itemsFilter.forEach(elm => elm.addEventListener('click', this.onClickItem.bind(this)));
        this.eventCLickCards();
    }

    onClickItem(evt){
        evt.preventDefault();

        this.btnFilter.querySelector('.title').textContent = evt.currentTarget.textContent;
        this.btnFilter.dataset.id = evt.currentTarget.dataset.id;

        this.closest('.container').querySelector('.content').classList.add('loading');

        this.btnFilter.parentNode.parentNode.classList.remove('active'); 
        this.btnFilter.nextElementSibling.style.cssText = 'height: 0;'; 

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({
              'Content-Type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
            }),
            body: new URLSearchParams(
              {
                action: 'filter_services',
                service: evt.currentTarget.dataset.id,
                industry: this.extraBtnFilter.dataset.id
              }
            ),
          })
          .then(response => response.json())
          .then(response => {
            // if(response.success){
                
                let currentPosts = this.closest('.container').querySelector('.content');
                currentPosts.innerHTML = '';
                currentPosts.insertAdjacentHTML('beforeend',response.data.projects);
                this.closest('.container').querySelector('.content').classList.remove('loading');
                this.loadBtn.dataset.paged = 1;
                this.loadBtn.classList.remove('disabled');
                this.eventCLickCards();
            // }

            if(response.data.last) { this.loadBtn.classList.add('hidden')}
            else{ this.loadBtn.classList.remove('hidden') }
            
        })
        .catch(err => () => {
            console.error(err);
        });
    }

    onClickBtn(evt){
        evt.preventDefault();
        this.extraActive.classList.remove('active');
        this.extraElement.style.cssText = "height: 0;";

        if(!this.active.classList.contains('active')){

            this.btnFilter.parentNode.parentNode.classList.remove('active'); 
            this.btnFilter.nextElementSibling.style.cssText = 'height: 0;'; 

            this.active.classList.add('active');
            this.element.style.cssText = `height: ${this.height}px;`;
        } else {
            this.active.classList.remove('active');
            this.element.style.cssText = "height: 0;";
        }
    }

    eventCLickCards(){
        this.cardBig = document.querySelectorAll('.card.big');
        this.cardBig.forEach(elm => elm.addEventListener('click', evt => { window.location.href = elm.dataset.url }));
    }
}
customElements.define('filter-services', filterProjectServices);

class filterProjectIndustries extends HTMLElement {
    constructor(){
        super();

        this.btnFilter = this.querySelector('.btn');
        this.extraBtnFilter = document.querySelector('filter-services .btn');
        this.itemsFilter = this.querySelectorAll('.item');
        this.active = this.parentNode;
        this.extraActive = document.querySelector('filter-services').parentNode;

        this.menu = this.btnFilter.dataset.name;
        this.element = this.querySelector('#'+this.menu);
        this.extraElement = document.querySelector('#service');
        this.height = this.element.scrollHeight;

        this.loadBtn = document.querySelector('load-moreprojects');

    }

    connectedCallback(){    
        this.btnFilter.addEventListener('click', this.onClickBtn.bind(this));
        this.itemsFilter.forEach(elm => elm.addEventListener('click', this.onClickItem.bind(this)));
    }

    onClickItem(evt){
        evt.preventDefault();

        this.btnFilter.querySelector('.title').textContent = evt.currentTarget.textContent;
        this.btnFilter.dataset.id = evt.currentTarget.dataset.id;

        this.closest('.container').querySelector('.content').classList.add('loading');

        this.btnFilter.parentNode.parentNode.classList.remove('active'); 
        this.btnFilter.nextElementSibling.style.cssText = 'height: 0;'; 

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({
              'Content-Type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
            }),
            body: new URLSearchParams(
              {
                action: 'filter_services',
                service: this.extraBtnFilter.dataset.id,
                industry: evt.currentTarget.dataset.id
              }
            ),
          })
          .then(response => response.json())
          .then(response => {
            // if(response.success){
                
                let currentPosts = this.closest('.container').querySelector('.content');
                currentPosts.innerHTML = '';
                currentPosts.insertAdjacentHTML('beforeend',response.data.projects);
                this.closest('.container').querySelector('.content').classList.remove('loading');
                this.loadBtn.dataset.paged = 1;
                this.loadBtn.classList.remove('disabled');
                this.eventCLickCards();
            // }

            if(response.data.last) { this.loadBtn.classList.add('hidden')}
            else{ this.loadBtn.classList.remove('hidden') }
            
        })
        .catch(err => () => {
            console.error(err);
        });
    }

    onClickBtn(evt){
        evt.preventDefault();
        this.extraActive.classList.remove('active');
        this.extraElement.style.cssText = "height: 0;";

        if(!this.active.classList.contains('active')){

            this.btnFilter.parentNode.parentNode.classList.remove('active'); 
            this.btnFilter.nextElementSibling.style.cssText = 'height: 0;'; 

            this.active.classList.add('active');
            this.element.style.cssText = `height: ${this.height}px;`;
        } else {
            this.active.classList.remove('active');
            this.element.style.cssText = "height: 0;";
        }
    }

    eventCLickCards(){
        this.cardBig = document.querySelectorAll('.card.big');
        this.cardBig.forEach(elm => elm.addEventListener('click', evt => { window.location.href = elm.dataset.url }));
    }
}

customElements.define('filter-industries', filterProjectIndustries);

/*****************************************END*****************************************/
